import type { ForwardedRef } from 'react';

import { useImperativeHandle, useMemo } from 'react';

import type { StoreProviderHooks, StoreProviderProps, StoreProviderRef } from './_.type';

/**
 * Use StoreProvider hooks.
 *
 * @param {StoreProviderProps} _props StoreProvider props.
 * @param {StoreProviderRef} ref StoreProvider ref.
 *
 * @returns {StoreProviderHooks} StoreProvider hooks.
 */
export default function useStoreProviderHooks(_props: StoreProviderProps, ref: ForwardedRef<StoreProviderRef>): StoreProviderHooks {
  useImperativeHandle(ref, () => ({}));

  return useMemo<StoreProviderHooks>(
    () => ({
      refs: {},

      states: {},

      events: {},
    }),
    [],
  );
}
